module.exports = __webpack_public_path__ + "img/group-red.2fb0d208.svg";